import { authHeader, store, history, tSafe, getLang, deviceTimezone } from "../_helpers";
import axios from "axios";

import { serverUrl, cardMode } from "../_constants";
import { reduxLoader } from "./reduxLoader.service";
import { orgConferencesActions } from "../_actions";
import { showGlobalSnackbar, showGlobalModal } from "./snackbarService";

export const userService = {
  getAsync,
  getWrapper,
  getWrapperWithPagination,
  putWrapper,
  postWrapper,
  patchWrapper,
  patchWrapperBody,
  delWrapper,
  awaitPost,
  uploadFile,
  setStorage,
  getStorage,
};

const UNAUTH = "Error: Request failed with status code 401";

// По умолчанию axios ждёт ответа бесконечно. Соединение, которое установилось,
// но ответа не отдаёт (мобильная сеть, VPN, проксирование), в таком случае не
// завершается ни успехом, ни ошибкой: колбэки не вызываются, и всё, что гасит
// спиннер в onSuccess/onError, не выполняется — экран остаётся с крутилкой
// навсегда. Тридцати секунд хватает и медленной сети из Китая (замеры к
// api.naviconf.cn — около секунды), а вышедший таймаут приходит обычной
// ошибкой в catch, то есть страница получает шанс показать сообщение.
axios.defaults.timeout = 30000;
// Загрузка файла — исключение: тут тридцати секунд мало (nginx пропускает до
// 100 МБ), поэтому лимит задаётся отдельно в uploadFile.
const UPLOAD_TIMEOUT = 300000;

function decodeBase64ToUtf8(base64String) {
  // Декодируем Base64 в бинарную строку
  const binaryString = atob(base64String);

  // Преобразуем бинарную строку в массив байтов
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // Декодируем массив байтов в UTF-8 строку
  const decoder = new TextDecoder("utf-8");
  return decoder.decode(bytes);
}

function showError(error) {
  // Обрыв связи: axios не донёс ответа (error.response === undefined), читать
  // error.response.data нечего. Без этой ветки исключение отсюда уходит
  // в unhandled rejection и съедает onError вызывающего — форма молча остаётся
  // в состоянии загрузки. В режиме «визитка» это выглядело как «обёртка не отдала
  // результат скана»: после первого же скана без связи FAB «Сканировать»
  // дизейблился навсегда, и в нативный лог не уходило ни строчки.
  if (!error || !error.response) {
    // В режиме «визитка» о потере связи сообщают сами экраны и своими словами
    // (скан офлайн ложится в очередь и говорит именно об этом), а разбор очереди
    // обязан быть молчаливым — человек его не запрашивал.
    if (!cardMode) showGlobalSnackbar(tSafe("network_error"), "error");
    return;
  }

  if (
    error.response.data &&
    error.response.data.required_changes &&
    typeof error.response.data.required_changes === "object"
  ) {
    return;
  }

  if (error.response.headers["n-frontend-snack"]) {
    const text = decodeBase64ToUtf8(error.response.headers["n-frontend-snack"]);

    showGlobalSnackbar(text, "error");
  } else {
    //console.log(error.response);
    // Через tSafe: бэкенд для части ошибок присылает i18n-ключ (snake_case), а не
    // готовую фразу — так сообщение приходит на языке интерфейса. Обычный текст
    // ключом не является и возвращается как есть.
    if (error.response.data.message)
      showGlobalSnackbar(tSafe(error.response.data.message), "error");
    else
      showGlobalSnackbar(JSON.stringify(error.response.data).replace(/^"(.*)"$/, '$1'), "error");
  }
}

function getAsync(urls, cbF) {
  const appToken = getStorage("token");
  const lang = getLang();
  axios.defaults.headers.get.Authorization = `Bearer ${appToken}`;
  axios.defaults.headers.get["N-Fixed-Locale"] = lang;
  axios.defaults.headers.get["N-Auto-Timezone"] = deviceTimezone();

  axios.defaults.headers.get["Content-Type"] = "application/json";
  axios.defaults.withCredentials = true;

  let aUrls = [];

  for (let i = 0; i < urls.length; i++)
    aUrls.push(axios.get(serverUrl + urls[i]));

  Promise.all(aUrls).then((values) => {
    cbF(values);
  });
}

function uploadFile(url, data, onSuccess, onError) {
  let appToken = getStorage("token");
  axios.defaults.headers.post.Authorization = `Bearer ${appToken}`;
  const lang = getLang();
  axios.defaults.headers.post["N-Fixed-Locale"] = lang;
  axios.defaults.headers.post["N-Auto-Timezone"] = deviceTimezone();

  axios
    .post(serverUrl + url, data, { timeout: UPLOAD_TIMEOUT })
    .then((response) => {

      if (response.headers["n-frontend-modal"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-modal"]);
        showGlobalModal(text, "error");
      }

      if (response.headers["n-frontend-snack"]) {
        showGlobalSnackbar(response.headers["n-frontend-snack"], "error");
      }
      onSuccess(response);
    })
    .catch((error) => {
      showError(error);

      onError(error);
    });
}

function getWrapper(url, onSuccess, onError, noRedirect = false) {
  let appToken = getStorage("token");
  const lang = getLang();
  axios.defaults.headers.get.Authorization = `Bearer ${appToken}`;
  axios.defaults.headers.get["N-Fixed-Locale"] = lang;
  axios.defaults.headers.get["N-Auto-Timezone"] = deviceTimezone();
  // alert(appToken);

  axios.defaults.headers.get["Content-Type"] = "application/json";
  axios.defaults.withCredentials = true;

  axios
    .get(serverUrl + url)
    .then((response) => {
      console.log(response);
      //snackbarService.success('Data saved successfully!');

      if (response.headers["n-frontend-modal"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-modal"]);
        showGlobalModal(text, "error");
      }

      if (response.headers["n-frontend-snack"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-snack"]);
        showGlobalSnackbar(text, "error");
      }

      onSuccess(response);
    })
    .catch((error) => {
      console.log("ERROR",error);
      if (error.response && error.response.message)
          showError(error.response.message);
        
      onError(error);
    });
}

function getWrapperWithPagination(url,pageNum,pageSize, onSuccess, onError, noRedirect = false) {
  let appToken = getStorage("token");
  const lang = getLang();
  axios.defaults.headers.get.Authorization = `Bearer ${appToken}`;
  axios.defaults.headers.get["N-Fixed-Locale"] = lang;
  axios.defaults.headers.get["N-Auto-Timezone"] = deviceTimezone();
  if (pageNum>0)
    axios.defaults.headers.get["N-Pagination-Pagenumber"] = pageNum;

  if (pageSize>0)
    axios.defaults.headers.get["N-Pagination-Pagesize"] = pageSize;
  // alert(appToken);

  axios.defaults.headers.get["Content-Type"] = "application/json";
  axios.defaults.withCredentials = true;

  axios
    .get(serverUrl + url)
    .then((response) => {
      console.log(response);
      //snackbarService.success('Data saved successfully!');

      if (response.headers["n-frontend-modal"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-modal"]);
        showGlobalModal(text, "error");
      }

      if (response.headers["n-frontend-snack"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-snack"]);
        showGlobalSnackbar(text, "error");
      }

      onSuccess(response);
    })
    .catch((error) => {
      console.log("ERROR",error);
      if (error.response && error.response.message)
          showError(error.response.message);
        
      onError(error);
    });
}

function putWrapper(url, data, onSuccess, onError) {
  let appToken = getStorage("token");
  axios.defaults.headers.put["X-Api-Key"] = appToken;

  axios.defaults.headers.put["Content-Type"] = "application/json";
  axios.defaults.withCredentials = true;

  axios
    .put(serverUrl + url, data)
    .then((response) => {

      if (response.headers["n-frontend-modal"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-modal"]);
        showGlobalModal(text, "error");
      }

      if (response.headers["n-frontend-snack"]) {

        const text = decodeBase64ToUtf8(response.headers["n-frontend-snack"]);
        showGlobalSnackbar(text, "error");
      }
      onSuccess(response);
    })
    .catch((error) => {
      if (error == UNAUTH) history.push("/login");
      //onError(error);
      else {
        showError(error);
      onError(error);
      }
    });
}

function patchWrapper(url, onSuccess, onError) {
  let appToken = getStorage("token");
  axios.defaults.headers.patch.Authorization = `Bearer ${appToken}`;
  const lang = getLang();
  axios.defaults.headers.patch["N-Fixed-Locale"] = lang;
  axios.defaults.headers.patch["N-Auto-Timezone"] = deviceTimezone();

  axios.defaults.headers.patch["Content-Type"] = "application/json";
  axios.defaults.withCredentials = true;

  axios
    .patch(serverUrl + url)
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      if (error == UNAUTH) history.push("/login");
      //onError(error);
      else {
        showError(error);
      onError(error);
      }
    });
}

function patchDispatchers(url) {
  switch (true) {
    case /api\/conference\/\d+/.test(url):
      reduxLoader.orgConferences(); //ToDo: update state without ajax-request
      break;
    case /api\/team\/\d+/.test(url):
      reduxLoader.team(); //ToDo: update state without ajax-request
      break;
    default:
  }
}

function patchWrapperBody(url, data, onSuccess, onError) {
  let appToken = getStorage("token");
  axios.defaults.headers.patch.Authorization = `Bearer ${appToken}`;
  const lang = getLang();
  axios.defaults.headers.patch["N-Fixed-Locale"] = lang;
  axios.defaults.headers.patch["N-Auto-Timezone"] = deviceTimezone();

  axios.defaults.headers.patch["Content-Type"] = "application/json";
  axios.defaults.withCredentials = true;

  axios
    .patch(serverUrl + url, data)
    .then((response) => {

      if (response.headers["n-frontend-modal"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-modal"]);
        showGlobalModal(text, "error");
      }

      if (response.headers["n-frontend-snack"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-snack"]);
        showGlobalSnackbar(text, "error");
      }
      onSuccess(response);
      patchDispatchers(url);
    })
    .catch((error) => {
      if (error == UNAUTH) history.push("/login");
      //onError(error);
      else {
        showError(error);
      onError(error);
      }
    });
}

function postDispatchers(url) {
  switch (url) {
    case "api/conference":
      reduxLoader.orgConferences(); //ToDo: update state without ajax-request
      break;
    case "api/team":
      reduxLoader.team(); //ToDo: update state without ajax-request
      break;
    default:
  }
}

function postWrapper(url, data, onSuccess, onError) {
  let appToken = getStorage("token");
  axios.defaults.headers.post.Authorization = `Bearer ${appToken}`;
  const lang = getLang();
  axios.defaults.headers.post["N-Fixed-Locale"] = lang;
  axios.defaults.headers.post["N-Auto-Timezone"] = deviceTimezone();

  axios.defaults.headers.post["Content-Type"] = "application/json";
  axios.defaults.withCredentials = true;
  console.log(url);

  axios
    .post(serverUrl + url, data)
    .then((response) => {
      console.log(response);


      if (response.headers["n-frontend-modal"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-modal"]);
        showGlobalModal(text, "error");
      }

      if (response.headers["n-frontend-snack"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-snack"]);
        showGlobalSnackbar(text, "error");
      }
      onSuccess(response);
      postDispatchers(url);
    })
    .catch((error) => {
      if (error == UNAUTH) history.push("/login");
      //onError(error);
      else {
        console.log(error);
        showError(error);
      onError(error);
      }
    });
}

function awaitPost(url) {
  let appToken = getStorage("token");
  axios.defaults.headers.post.Authorization = `Bearer ${appToken}`;

  axios.defaults.headers.post["Content-Type"] = "application/json";
  axios.defaults.withCredentials = true;

  let data = axios.post(serverUrl + url);
  console.log(data);

  return data;
}

function delDispatchers(url) {
  switch (true) {
    case /api\/conference\/\d+/.test(url):
      store.dispatch(orgConferencesActions.del(url.match(/\d+/)[0]));
      break;
    case /api\/team\/\d+/.test(url):
      reduxLoader.team(); //ToDo: update state without ajax-request
      break;
    default:
  }
}

function delWrapper(url, onSuccess, onError) {
  let appToken = getStorage("token");
  axios.defaults.headers.delete.Authorization = `Bearer ${appToken}`;

  axios.defaults.withCredentials = true;

  axios
    .delete(serverUrl + url)
    .then((response) => {


      if (response.headers["n-frontend-modal"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-modal"]);
        showGlobalModal(text, "error");
      }

      if (response.headers["n-frontend-snack"]) {
        const text = decodeBase64ToUtf8(response.headers["n-frontend-snack"]);
        showGlobalSnackbar(text, "error");
      }
      onSuccess(response);
      delDispatchers(url);
    })
    .catch((error) => {
      if (error == UNAUTH) history.push("/login");
      // onError(error);
      else {
        // Именно error, а не error.response.headers: без связи response нет вовсе,
        // и обращение к нему бросало бы исключение мимо showError — вместе
        // с onError вызывающего.
        console.log(error);
        showError(error);
    onError(error);
      }
    });
}

function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function getStorage(name) {
  return localStorage.getItem(name);
}

function setStorage(name, val) {
  localStorage.setItem(name, val);
}
